import React from 'react';
import { ButtonGroup } from '@mui/material';
import Icon from '@mdi/react';
import { mdiEye, mdiPencil } from '@mdi/js';
import Button from '../../../src/components/library/Button';

interface EditViewModeToggleButtonProps {
	onClickHandler: (editMode: boolean) => void;
	editMode: boolean;
}

export function EditViewModeToggleButton({ onClickHandler, editMode }: EditViewModeToggleButtonProps) {
	return (
		<ButtonGroup>
			<Button
				nxstyle="secondary-black"
				className="active"
				$disablePadding
				$forceActive={!editMode}
				onClick={() => onClickHandler(false)}
				aria-label="View Mode"
			>
				<Icon path={mdiEye} size="16px" />
			</Button>
			<Button
				nxstyle="secondary-black"
				$disablePadding
				$forceActive={editMode}
				onClick={() => onClickHandler(true)}
				aria-label="Edit Mode"
			>
				<Icon path={mdiPencil} size="16px" />
			</Button>
		</ButtonGroup>
	);
}
